const sliderOptions = {
  ['.js-featured-mobile-slider']: {
    items: 1.125,

    responsive: {
      400: {
        items: 1.5,
      },
      600: {
        disable: true,
      },
    },
  },
  ['.js-collection-preview-slider']: {
    items: 1.125,

    responsive: {
      400: {
        items: 1.5,
      },
      768: {
        items: 1.75,
        edgePadding: 18,
      },
      1024: {
        items: 2.25,
      },
      1200: {
        items: 2.75,
      },
    },
  },
  ['.js-collection-card-slider']: {
    fixedWidth: 225,
    gutter: 12,

    responsive: {
      600: {
        fixedWidth: 250,
      },
      768: {
        fixedWidth: 275,
        edgePadding: 18,
        gutter: 20,
      },
      1200: {
        items: 4.125,
        fixedWidth: false,
      },
    },
  },
  ['.js-podcast-tease-slider']: {
    items: 1.125,

    responsive: {
      450: {
        items: 1.5,
      },
      768: {
        edgePadding: 18,
        items: 2.125,
      },
      1024: {
        disable: true,
      },
    },
  },
  ['.js-book-slider']: {
    items: 2.5,

    responsive: {
      768: {
        edgePadding: 18,
        items: 3.5,
      },
      1200: {
        items: 4.5,
      },
      1400: {
        items: 5,
      },
    },
  },
  ['.js-collection-episode-slider']: {
    items: 1.5,

    responsive: {
      600: {
        items: 2.125,
      },
      768: {
        edgePadding: 18,
      },
      1200: {
        items: 2.625,
      },
    },
  },
  ['.js-hub-episode-slider']: {
    items: 1.125,

    responsive: {
      600: {
        items: 2.25,
      },
      768: {
        edgePadding: 18,
      },
      960: {
        items: 3,
      },
    },
  },
  ['.js-podcast-recirc-slider']: {
    items: 1.125,

    responsive: {
      600: {
        items: 2.25,
      },
      768: {
        edgePadding: 18,
      },
      960: {
        items: 3,
      },
    },
  },
  ['.js-topic-slider']: {
    autoWidth: true,
    edgePadding: 3,
    slideBy: 'page',
    loop: true,
    rewind: false,
  },
};

export default sliderOptions;
